import React, { useEffect, useState } from "react";

const AttributeList = ({ attributes, handleCheckChange, selectAttributes }) => {
  const [localAttributes, setLocalAttributes] = useState([]);

  useEffect(() => {
    setLocalAttributes(attributes || []);
  }, [attributes]);

  return (
    <div className="gog-dept-picker-list">
      <div className="gog-dept-picker-header">
        <span>Step 3</span>
        <h4>Must Have</h4>
        <p>Select the attributes required for your search.</p>
      </div>

      <div className="gog-dept-attribute-list">
        {localAttributes.length > 0 ? (
          localAttributes.map((att) => {
            if (att.isTitle) {
              return (
                <div key={att.id} className="gog-dept-attribute-title">
                  {att.name}
                </div>
              );
            }

            const isChecked = selectAttributes.some((at) => at === att.id);

            return (
              <label
                key={att.id}
                htmlFor={String(att.id)}
                className={`gog-dept-attribute-row ${
                  isChecked ? "active" : ""
                }`}
              >
                <span>{att.name}</span>

                <input
                  type="checkbox"
                  id={String(att.id)}
                  checked={isChecked}
                  onChange={handleCheckChange}
                />

                <i />
              </label>
            );
          })
        ) : (
          <div className="gog-dept-empty">
            Select a type to view available attributes.
          </div>
        )}
      </div>
    </div>
  );
};

export default AttributeList;